import { render, staticRenderFns } from "./employeeBulkTagDialog.vue?vue&type=template&id=f6b5d2a8"
import script from "./employeeBulkTagDialog.vue?vue&type=script&lang=js"
export * from "./employeeBulkTagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports